import React, { useState, useEffect } from 'react';

import makeClassName from 'shared-utils/src/makeClassName';

export default function Tooltip({
  text,
  revealed,
  hidden,
  offset = {},
  width = null,
  className,
}) {
  const [toState, setToState] = useState(null);
  const [isRevealed, setIsRevealed] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  
  const tooltipCls = makeClassName([
    className,
    isRevealed ? ' revealed' : '',
    isHidden ? ' hidden' : '',
  ]);

  useEffect(() => {
    if (revealed) {
      clearTimeout(toState);      
      setIsHidden(false);
      setIsRevealed(true);
    } else if (hidden) {
      setIsHidden(true);
      const to = setTimeout(() => {
        setIsRevealed(false);
        setIsHidden(false);
      }, 501);
      setToState(to);
    }
  }, [revealed, hidden]);

  return (
    <div 
      style={{ ...offset, width }}
      className={tooltipCls}
    >
      {text}
    </div>
  );
}